define('appkit/util/bind.radio',['require','exports','module','underscore','backbone.radio'],function(require, exports, module) {
  var _ = require('underscore');
  var Radio = require('backbone.radio');
    
  exports.parseChannelAndName = function(channelAndName, defaultChannelName) {
    var sections = String(channelAndName).split(/\s+/),
        channelName = null,
        name        = null;

    if (sections.length == 1) {
      channelName = defaultChannelName || 'global';
      name = channelAndName;
    } else {
      channelName = sections[0];
      name = sections.slice(1).join(' ');
    }
    return { name: name, channelName: channelName };
  };


  exports.bindRequests = function(target, bindings) {
    _.each(bindings, function(method, channelAndReplyName) {
      if (!String(channelAndReplyName).trim()) { return; }
      
      var channelAndName = exports.parseChannelAndName(channelAndReplyName, target.channelName),
          channelName    = channelAndName.channelName,
          replyName      = channelAndName.name,
          callback       = null;

      if (method == '@this') {
        callback = _.constant(target);
      } else if (_.isFunction(method)) {
        callback = method;
      } else if (_.has(target, method)) {
        callback = target[method];
      } else {
        throw Error('Cannot find proper callback for request "' + channelAndReplyName + '"');
      }

      Radio.channel(channelName)
          .reply(replyName, callback, target);
    });
  };

  exports.bindEvents = function(target, bindings) {
    _.each(bindings, function(method, channelAndEvent) {
      if (!String(channelAndEvent).trim()) { return; }

      var channelAndName = exports.parseChannelAndName(channelAndEvent),
          channelName    = channelAndName.channelName,
          event          = channelAndName.name,
          channel        = null,
          callback       = null;

      if (_.isFunction(method)) {
        callback = method;
      } else if (_.isFunction(target[method])) {
        callback = target[method];
      } else {
        throw Error('Cannot find proper event callback');
      }

      Radio.channel(channelName).on(event, callback, target);
    });
  };

});
